(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sticker"] && !Shopify.designMode) return;
  try {
    (function () {
    function reveal(el) {
      if (el.dataset.sbRevealReady === 'true') return;
      el.dataset.sbRevealReady = 'true';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) { el.classList.add('is-revealed'); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { el.classList.add('is-revealed'); io.disconnect(); }
      }, { threshold: 0.25 });
      io.observe(el);
    }
    function boot() {
      var els = document.querySelectorAll('.sticker-block--reveal');
      for (var i = 0; i < els.length; i++) reveal(els[i]);
    }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    function initTabs(root) {
      if (root.dataset.wtReady === 'true') return;
      root.dataset.wtReady = 'true';

      var tabs = root.querySelectorAll('.wtabs__tab');
      var panels = root.querySelectorAll('.wtabs__panel');

      function activate(n) {
        for (var i = 0; i < tabs.length; i++) {
          var on = tabs[i].getAttribute('data-wtab') === n;
          if (on) { tabs[i].classList.add('is-active'); } else { tabs[i].classList.remove('is-active'); }
          tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        for (var p = 0; p < panels.length; p++) {
          var pon = panels[p].getAttribute('data-wpanel') === n;
          if (pon) { panels[p].classList.add('is-active'); panels[p].removeAttribute('hidden'); }
          else { panels[p].classList.remove('is-active'); panels[p].setAttribute('hidden', ''); }
        }
      }

      for (var i = 0; i < tabs.length; i++) {
        (function (tab) {
          tab.addEventListener('click', function () { activate(tab.getAttribute('data-wtab')); });
        })(tabs[i]);
      }
    }

    function boot() {
      var all = document.querySelectorAll('.wtabs');
      for (var i = 0; i < all.length; i++) initTabs(all[i]);
    }

    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
